import { Pipe, PipeTransform } from '@angular/core';
import { MetaTagsService } from 'src/app/services/meta-tags.service';

@Pipe({
  name: 'linkedin'
})
export class LinkedinPipe implements PipeTransform {

  constructor(
    private MetaTagsService: MetaTagsService
  ) { }

  transform(link: string, metaData: any): string {
    const pageMetaData = this.MetaTagsService.getPageMetaTags();
    return encodeURI(`https://www.linkedin.com/shareArticle?mini=true&url=${pageMetaData?.url}&title=${pageMetaData?.title}&summary=${pageMetaData?.description}&source=WOQOD`);
  }

}
